import React from "react";
import AdminShell from "./AdminShell";

function AdminFormPage({ title, children }) {
  return (
    <AdminShell>
      <div className="row grid-margin">
        <div className="col-12">
          <div className="card admin-form-card">
            <div className="card-body">
              <h4 className="card-title">{title}</h4>
              {children}
            </div>
          </div>
        </div>
      </div>
    </AdminShell>
  );
}

export default AdminFormPage;
